import { FC, PropsWithChildren } from 'react'
import clsx from 'clsx'
import ClipboardButton from 'components/molecules/clipboard-button'
import SocialLink from 'components/atoms/social-link'

interface Props {
	url: string
	data?: any
	className?: string
	itemClassName?: string
	loading?: boolean
	handleCopy?: (...args: any[]) => void
	isCopied?: boolean
	setIsCopied?: (...args: any[]) => void
	/** Leave out the leading copy-link button, e.g. when the link is already shown with its own Copy action. */
	showCopyButton?: boolean
}

const SocialShareBlock: FC<PropsWithChildren<Props>> = ({
	data,
	url,
	className = '',
	itemClassName,
	loading,
	handleCopy,
	isCopied,
	setIsCopied,
	showCopyButton = true,
}) => {
	const baseItemClass = itemClassName ?? 'w-10 h-10 bg-secondary-surface/[0.2] backdrop-blur-lg bg-opacity-50'
	const encodedUrl = encodeURIComponent(url)
	const encodedTitle = encodeURIComponent(data?.title ?? 'Loyalink')

	return (
		<ul className={clsx('flex items-center justify-start gap-2 flex-wrap', className)}>
			{showCopyButton && (
				<li>
					<ClipboardButton
						url={url}
						className={baseItemClass}
						loading={loading}
						onCopy={handleCopy}
						isCopied={isCopied}
						setIsCopied={setIsCopied}
					/>
				</li>
			)}
			<li>
				<SocialLink
					icon="twitter"
					href={`https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`}
					title="Twitter"
					className={baseItemClass}
				/>
			</li>
			<li>
				<SocialLink
					icon="facebook-f"
					href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}&src=sdkpreparse`}
					title="Facebook"
					className={baseItemClass}
				/>
			</li>
			<li>
				<SocialLink
					icon="reddit"
					href={`https://reddit.com/submit?url=${encodedUrl}&title=${encodedTitle}`}
					title="Reddit"
					className={baseItemClass}
				/>
			</li>
			<li>
				<SocialLink
					icon="linkedin"
					href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`}
					title="LinkedIn"
					className={baseItemClass}
				/>
			</li>
		</ul>
	)
}

export default SocialShareBlock
